import { inr, fmtDate } from "../lib/api";

export const BranchComparison = ({ entries, branches }) => {
  if (branches.length < 1 || !entries.length) return null;
  const byDay = {};
  entries.forEach((e) => {
    const d = (byDay[e.date] ||= {});
    const b = (d[e.branch_id] ||= { deposit: 0, withdraw: 0 });
    b[e.type] += e.amount;
  });
  const dates = Object.keys(byDay).sort().reverse();
  return (
    <div className="bg-surface border border-line overflow-x-auto" data-testid="branch-comparison">
      <div className="px-4 py-3 border-b border-line">
        <h2 className="font-display text-base md:text-lg font-semibold">Branch-wise Daily Comparison</h2>
      </div>
      <table className="w-full text-sm" style={{ minWidth: 160 + branches.length * 240 }}>
        <thead className="bg-head border-b border-line">
          <tr className="font-mono text-[11px] uppercase tracking-wider text-muted-c">
            <th rowSpan={2} className="px-4 py-2 text-left align-bottom">Date</th>
            {branches.map((b) => <th key={b.id} colSpan={2} className="px-4 pt-2 text-center text-brand border-l border-line">{b.name}</th>)}
          </tr>
          <tr className="font-mono text-[10px] uppercase tracking-wider text-muted-c">
            {branches.map((b) => [
              <th key={`${b.id}d`} className="px-4 py-2 text-right border-l border-line">Deposit</th>,
              <th key={`${b.id}w`} className="px-4 py-2 text-right">Withdraw</th>,
            ])}
          </tr>
        </thead>
        <tbody>
          {dates.map((d) => (
            <tr key={d} className="border-b border-line/60 row-hover" data-testid={`branch-comparison-row-${d}`}>
              <td className="px-4 py-2 font-mono whitespace-nowrap">{fmtDate(d)}</td>
              {branches.map((b) => {
                const v = byDay[d][b.id];
                return [
                  <td key={`${b.id}d`} className="px-4 py-2 text-right font-mono text-pos border-l border-line">{v?.deposit ? inr(v.deposit) : "–"}</td>,
                  <td key={`${b.id}w`} className="px-4 py-2 text-right font-mono text-neg">{v?.withdraw ? inr(v.withdraw) : "–"}</td>,
                ];
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
